import $ from "jquery";
import "bootstrap-sass";

/* eslint-enable */

// Bootstrap v3.3.7 PR to fix leaks broke other things: https://github.com/twbs/bootstrap/pull/19659
// Fixing this issue: https://github.com/twbs/bootstrap/issues/20511
// Temp fix until v4 update
/* eslint-disable */
$.fn.tooltip.Constructor.prototype.show = function() {
    var e = $.Event("show.bs." + this.type);

    if (this.hasContent() && this.enabled) {
        this.$element.trigger(e);

        var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
        if (e.isDefaultPrevented() || !inDom) return;
        var that = this;

        var $tip = this.tip();

        var tipId = this.getUID(this.type);

        this.setContent();
        $tip.attr("id", tipId);
        this.$element.attr("aria-describedby", tipId);

        if (this.options.animation) $tip.addClass("fade");

        var placement = typeof this.options.placement == "function" ?
            this.options.placement.call(this, $tip[0], this.$element[0]) :
            this.options.placement;

        var autoToken = /\s?auto?\s?/i;
        var autoPlace = autoToken.test(placement);
        if (autoPlace) placement = placement.replace(autoToken, "") || "top";

        $tip
            .detach()
            .css({ top: 0, left: 0, display: "block" })
            .addClass(placement)
            .data("bs." + this.type, this);

        this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
        this.$element.trigger("inserted.bs." + this.type);

        var pos          = this.getPosition();
        var actualWidth  = $tip[0].offsetWidth;
        var actualHeight = $tip[0].offsetHeight;

        if (autoPlace) {
            var orgPlacement = placement;
            var viewportDim = this.getPosition(this.$viewport);

            placement = placement == "bottom" && pos.bottom + actualHeight > viewportDim.bottom ? "top"    :
                placement == "top"    && pos.top    - actualHeight < viewportDim.top    ? "bottom" :
                    placement == "right"  && pos.right  + actualWidth  > viewportDim.width  ? "left"   :
                        placement == "left"   && pos.left   - actualWidth  < viewportDim.left   ? "right"  :
                            placement;

            $tip
                .removeClass(orgPlacement)
                .addClass(placement);
        }

        var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);

        this.applyPlacement(calculatedOffset, placement);

        var complete = function() {
            var prevHoverState = that.hoverState;
            if (that.$element) {
                that.$element.trigger("shown.bs." + that.type);
            }
            that.hoverState = null;

            if (prevHoverState == "out") that.leave(that);
        };

        $.support.transition && this.$tip.hasClass("fade") ?
            $tip
                .one("bsTransitionEnd", complete)
                .emulateTransitionEnd($.fn.tooltip.Constructor.TRANSITION_DURATION) :
            complete();
    }
};
/* eslint-enable */

// Override Bootstrap's destroy for tooltips and popovers to check for presence of an element before attempting to cancel events on it
$.fn.tooltip.Constructor.prototype.destroy = function() {
    const that = this;
    clearTimeout(this.timeout);
    this.hide(() => {
        if (that.$element) {
            that.$element.off(`.${that.type}`).removeData(`bs.${that.type}`);
        }
        if (that.$tip) {
            that.$tip.detach();
        }
        that.$tip = null;
        that.$arrow = null;
        that.$viewport = null;
        that.$element = null;
    });
};
$.fn.popover.Constructor.prototype.destroy = $.fn.tooltip.Constructor.prototype.destroy;

// Add bootstrap's tooltips
const $body = $("body");
$body.tooltip({
    selector: "[data-toggle=\"tooltip\"]",
    container: "body"
}).on("hidden.bs.tooltip", (e) => {
    // See https://github.com/Pazien/web-application/pull/324 for the reason to defer destroying with setTimeout
    setTimeout(() => {
        $(e.target).tooltip("destroy");
    }, 100);
});

// Add bootstrap popovers
$body.popover({
    selector: ".pz-popover",
    container: "body",
    trigger: "hover"
});

$(document).ready(() => {
    $("body").on("mouseenter", "td", (e) => {
        const cell = e.currentTarget;
        // Don't add another title if already set
        if (cell.getAttribute("title")) {
            return;
        }
        const { scrollWidth, offsetWidth } = cell;
        if (offsetWidth < scrollWidth) {
            cell.setAttribute("title", cell.textContent);
        }
    });
});
